import React , { useState, useEffect  } from 'react';
import { Button, Input, Modal, ModalBody, ModalHeader, Row , Col} from 'reactstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { close_add_db_modal, open_add_db_modal, set_db_connection_db_name, set_db_connection_ip, set_db_connection_login_name, set_db_connection_name, set_db_connection_password, set_db_connection_port, set_db_connection_type } from '../../../slices/Select_DB_Modal/reducer';
import Loader from '../Loader';
import { Edit_DB_Connection, Save_New_DB_Connection } from '../../../slices/thunks';
import { useLocation, useNavigate } from 'react-router-dom';
import config from '../../../config';
import { base64ToFile } from '../../../slices/layouts/utils';




const Select_New_DB_Modal = () => {
  const select_db_modal_state = useSelector((state)=> state.Select_DB_Modal)
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const location = useLocation()
  const {Group}  = useSelector((state)=>state.Create_Bot)
  const [modal_animationZoom, setmodal_animationZoom] = useState(select_db_modal_state.add_new_db_modal_open);
  const create_bot_details = useSelector((state)=> state.Create_Bot)
  const dispatch = useDispatch();
  function tog_db_animationZoom() {
     if(!modal_animationZoom){
         dispatch(open_add_db_modal(!modal_animationZoom))
     }else{
      dispatch(close_add_db_modal(!modal_animationZoom))
     }
     setmodal_animationZoom(!modal_animationZoom);
  } 
   

  useEffect(() => {
     
    setmodal_animationZoom(select_db_modal_state.add_new_db_modal_open)


  
  }, [select_db_modal_state])
  const {edit_mode } = select_db_modal_state
  


  return (
    <>
      {!pathname.includes('Group_Dashboard') &&<Button className="btn rounded-pill" color="primary" onClick={() => tog_db_animationZoom()} >Create New DB</Button>}
      
      <Modal id="flipModal" isOpen={modal_animationZoom} toggle={() => { tog_db_animationZoom(); }} modalClassName="zoomIn modal-lg" centered >
                { <ModalHeader className="modal-title" id="flipModalLabel" toggle={() => { tog_db_animationZoom(); }}>
                {edit_mode ? "Update Database Connection":"Add new DB"}
                </ModalHeader>}
                {select_db_modal_state.loading? <Loader/>:<form onSubmit={(e)=>{
                     e.preventDefault();

                     const {Connection_Name,Login_Name,IP,Database_Name,Type,Port,Password , Database_ID , Group_ID } = select_db_modal_state


                    //  console.log(base64ToFile(JSON.parse(create_bot_details.Bot_Logo),'Image'));
                     
                     if (!edit_mode)
                    { dispatch(
                       Save_New_DB_Connection({
                         Group_ID:Group_ID ? Group_ID : create_bot_details.Group,
                         Connection_Name ,
                         Login_Name,
                         Password,
                         IP,
                         Database_Name,
                         Type, //MYSQL,
                         Port,
                         pathname: location.pathname,
                        //  databaseId: select_db_modal_state.database_id, // here the id will get set after the DB Selection 
                        //  Group_ID: create_bot_details.Group,
                         max_record: config.general_config.max_records,
                         bot_allow_see_source: config.general_config.bot_allow_see_source,
                         BOT_Category: create_bot_details.BOT_Category,
                         Bot_Sample_Question:create_bot_details.Sample_Question, // ask khalid sir to add in combine 
                         model: create_bot_details.Model,
                         instructions:create_bot_details.Instruction,
                         title: create_bot_details.Bot_Name,
                         description: create_bot_details.Bot_Description,
                         Query_Model: create_bot_details.SQL_Model,
                         structure: [],
                         logo:base64ToFile(JSON.parse(create_bot_details.Bot_Logo))
                       },navigate)
                     );
                    }else{
                      // console.log(edit_mode , "Edit Mode")
                      dispatch(Edit_DB_Connection({
                        "login_name":Login_Name,
                        "password":Password,
                        "ip":IP,
                        "dbname":Database_Name,
                        "connection_name":Connection_Name,
                        "type":Type,
                        "port":Port,
                        "group_id":Group_ID,
                        "database_id":Database_ID
                      }))
                    }


                }} >
                <ModalBody>
                  <div className='add_website_link mt-30'>
                      <p>DB Type *</p>
                      <select 
                      required={true}
                      onChange={(e)=>{

                        dispatch(set_db_connection_type(e.target.value))

                      }} 
                      class="form-select mb-3" aria-label="Default select example">
                          <option></option>
                          <option selected={ select_db_modal_state.Type ==='MYSQL' } value="MYSQL">MYSQL</option>
                          <option  selected={ select_db_modal_state.Type ==='MSSQL' } value="MSSQL">MSSQL</option>
                          <option  selected={ select_db_modal_state.Type ==='POSTGRESQL' } value="POSTGRESQL">POSTGRESQL</option>
                          <option  selected={ select_db_modal_state.Type ==='ORACLE' } value="ORACLE">ORACLE</option>
                          <option  selected={ select_db_modal_state.Type ==='MONGODB' } value="MONGODB">MONGODB</option>
                          <option  selected={ select_db_modal_state.Type ==='MONGODB_ATLAS' } value="MONGODB_ATLAS">MONGODB ATLAS</option>

                      </select>
                  </div>

                 
                  <div className='add_website_link mt-30'>
                      <p>Connection name *</p>
                      <Input 
                      required={true}
                      value={select_db_modal_state.Connection_Name}
                      onChange={(e)=>{
                      
                        dispatch(set_db_connection_name(e.target.value))

                      }} 
                       className="connection_name" type="text" name="inlineRadioOptions" id="connection_name"/>
                  </div>
                  <Row className='mt-30'>
                      <Col>
                        <label for="host" class="form-label">Host *</label>
                        <Input  
                        required={true}
                         value={select_db_modal_state.IP}
                      onChange={(e)=>{

                        dispatch(set_db_connection_ip(e.target.value))

                      }} 
                       type="text" class="form-control" id="host" />                       
                     </Col>
                     <Col>
                        <label for="database_name" class="form-label">Database Name *</label>
                        <Input 
                        required={true}
                        value={select_db_modal_state.Database_Name} 
                        onChange={(e)=>{

                        dispatch(set_db_connection_db_name(e.target.value))

                      }} 
                       type="text" class="form-control" id="database_name" />                       
                     </Col> 
                     <Col>
                        <label for="port" class="form-label">Port </label>
                        <Input
                        type="number"  
                        required={false}
                        value={select_db_modal_state.Port ? select_db_modal_state.Port : " "} 
                      onChange={(e)=>{

                        dispatch(set_db_connection_port(e.target.value))

                      }} 
                        class="form-control" id="port" />                       
                     </Col>                      
                  </Row>
                  <Row className='mt-30'>
                      <Col>
                        <label for="user_name" class="form-label">User name *</label>
                        <Input  
                        required={true}
                        value={select_db_modal_state.Login_Name} 
                      onChange={(e)=>{

                        dispatch(set_db_connection_login_name(e.target.value))

                      }} 
                       type="text" class="form-control" id="user_name" />                       
                     </Col>
                     <Col>
                        <label for="password" class="form-label">Password *</label>
                        <Input  
                        required={true}
                        value={select_db_modal_state.Password} 
                      onChange={(e)=>{

                        dispatch(set_db_connection_password(e.target.value))

                      }} 
                       type="password" class="form-control" id="password" />                       
                     </Col>                      
                  </Row>
              </ModalBody><div className="modal-footer justify-content-center">
                      <Button className="rounded-pill btn" color="light" onClick={() => { 
                        tog_db_animationZoom(); 
                     
                       } }> Cancel </Button>
                     <Button type="submit" className="rounded-pill btn" color="primary">{!edit_mode?'Save':'Update'}</Button> 
                  </div>
                  </form>}
       </Modal>
    </>
  )
}

export default Select_New_DB_Modal
